import * as React from "react";
import "./spinner.scss";

export default () => <div className="spinner"></div>;
